// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fv-0";